/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ItemCategories
//   Details:    Item categories constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103782 10/12/19 JC  M01  Added stringFromUTF8Array
// 106452 04/03/20 JC  M02  Added detectCompatibleBrowser, detectIE
// 103839 06/04/20 JC  M03  Added formatValue
// 108238 09/06/20 JC  M04  Added getDateFormat, getTimeFormat, getDateTimeFormat
// 108958 24/08/20 JC  M05  Added applyFrameKiller
// 115164 12/10/21 JC  M06JC    Added FormatEnumString
// WI2232 02/02/23 JC  M07JC    Added getDayFormat, getDayAndDateFormat, getDayAndDateTimeFormat
//-------------------------------------------------------
*/

import DOMPurify from "dompurify"; //M02

export const utils = {
    truncateDate,
    byteArrayToString, //M01
    getSafeHTML, //M01
    detectCompatibleBrowser, //M02
    formatValue, //M03
    getDateFormat, //M04
    getTimeFormat, //M04
    getDayFormat, //M07JC
    getDayAndDateFormat, //M07JC
    getDateTimeFormat, //M04
    getDayAndDateTimeFormat, //M07JC
    applyFrameKiller, //M05
    formatEnumString //M06JC
};

function truncateDate(date) {
    let pos = date.indexOf("T");
    if (pos !== -1)
        return date.substr(0, pos);
    return date;
}

// M01 base64 encoded ascii to ucs-2 string
function byteArrayToString(array) {
    return decodeURIComponent(escape(window.atob(array)));
}

// M01 base64 encoded ascii to ucs-2 string
function getSafeHTML(htmlContent) {
    //default to blank string
    let html = "";

    //if we've got any note html conent
    if (htmlContent) {

        //convert to a string
        html = utils.byteArrayToString(htmlContent);

        //and purify using DOMPurify
        htmlContent = DOMPurify.sanitize(htmlContent)
    }

    return {
        //return in correct format
        __html: html
    };

}

// M02 detect compatible browser
function detectCompatibleBrowser() {

    //any browser that isn't IE is compatible
    return !detectIE()
}

//M05 apply frame killer
function applyFrameKiller() {

    //delegate to private
    return vApplyFrameKiller();
}

//M03 format value
function formatValue(value, inputType, decimalPlaces) {
    if (inputType === "checkbox") {
        return value.toLowerCase() === "true" ? true : false;
    }
    else if (inputType === "number") {
        var numeric = parseFloat(value);
        return isNaN(numeric)
            ? ""
            : numeric.toFixed(decimalPlaces);
    }
    return value;
}

//M04 get date format - these are temporary for consistency across application, but should really be replaced with mooment locale settings at some point
function getDateFormat() {
    return "DD/MM/YYYY";
}

//M04 get time format - these are temporary for consistency across application, but should really be replaced with mooment locale settings at some point
function getTimeFormat() {
    return "HH:mm";
}

//M07JC  get day format - these are temporary for consistency across application, but should really be replaced with mooment locale settings at some point
function getDayFormat() {
    return "ddd";
}

//M07JC  get day and date format - these are temporary for consistency across application, but should really be replaced with mooment locale settings at some point
function getDayAndDateFormat() {
    return getDayFormat() + " " + getDateFormat();
}

//M04 get date time format - these are temporary for consistency across application, but should really be replaced with mooment locale settings at some point
function getDateTimeFormat() {
    return getDateFormat() + " " + getTimeFormat();
}

//M07JC get day date time format - these are temporary for consistency across application, but should really be replaced with mooment locale settings at some point
function getDayAndDateTimeFormat() {
    return getDayFormat() + " " + getDateTimeFormat();
}

//M06JC format enum string
function formatEnumString(forString) {
    let sReturnString = "";

    //if a string passed
    if (typeof forString === 'string') {
        //start with passed string
        sReturnString = forString;

        //perform string replaces
        sReturnString = sReturnString.replaceAll("_", " ");

        //capitalise first letter
        sReturnString = sReturnString[0].toUpperCase() + sReturnString.substring(1)
    }

    //return
    return sReturnString
}

// #region Private functions

// M02 detect if IE exists (private)
function detectIE() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    //commented out as Edge is okay          
    //var edge = ua.indexOf('Edge/');
    //if (edge > 0) {
    //    // Edge (IE 12+) => return version number
    //    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    //}

    // other browser
    return false;
}

// M05 apply frame killer
function vApplyFrameKiller() {

    if (window.self == window.top) {
        document.documentElement.style.display = 'block';
    } else {
        window.top.location = window.self.location;
    }

    return true;
}

// #endregion